/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function r(r,o){if(!r)throw new Error("ASSERT: "+o)}export{r as assert};
